import { configureStore } from '@reduxjs/toolkit';

import billing from './billing';
import checkout from './checkout';
import collaborators from './collaborators';
import editor from './editor';
import myDocuments from './myDocuments';
import profile from './profile';
import share from './share';
import site from './site';

const store = configureStore({
	reducer: {
		profile,
		site,
		editor,
		myDocuments,
		collaborators,
		checkout,
		billing,
		share
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false
		}),
	devTools: import.meta.env.MODE !== 'production'
});

export default store;
